import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import AppCardItem from "./AppCardItem";

function AppCardGrid(props) {
  const items = props.items;
  return (
    <Row>
      {items &&
        items.map((item, idx) => (
          <Col key={idx}>
            <AppCardItem
              title={item.title}
              text={item.text}
              displayButton={item.displayButton}
              cardWidth={item.cardWidth}
              paddingTop={item.paddingTop}
              onClick={item.buttonOnClick}
              buttonText={item.buttonText}
            />
          </Col>
        ))}
    </Row>
  );
}

export default AppCardGrid;
